Vue.use(PanelDataSource);

const JobsView = {
  components: {
    Adsense,
    ProfilesBox: _profileBox,
  },
  data() {
    return {
      saved: false,
      job: {
        type: '',
        title: '',
        description: '',
        requisites: '',
        activity: {},
        location: {},
        tos: false,
      },
      applications: [],
      profiles: { docs: [] },
      employment: [
        {
          id: 'FULL_TIME',
          label: 'Tiempo completo',
        },
        {
          id: 'PART_TIME',
          label: 'Tiempo parcial',
        },
        {
          id: 'TEMPORARY',
          label: 'Temporal',
        },
        {
          id: 'PER_DIEM',
          label: 'Por día/hora',
        },
        {
          id: 'CONTRACTOR',
          label: 'Por obra',
        },
        {
          id: 'OTHER',
          label: 'Otro',
        },
      ],
      statuses: {
        draft: 'Borrador',
        pending: 'Pendiente',
        active: 'Activa',
        inactive: 'Inactiva',
        closed: 'Cerrada',
      },
      types: [
        {
          id: 'ONSITE',
          label: 'Presencial',
        },
        {
          id: 'HYBRID',
          label: 'Híbrido',
        },
        {
          id: 'ONLINE',
          label: 'Remoto',
        },
      ],
    };
  },
  computed: {
    user() {
      return domestiko.user;
    },
    employmentLabel() {
      if (!this.job?.employment) return '';
      return this.employment.find((e) => e.id === this.job.employment).label;
    },
    placeLabel() {
      if (!this.job?.place) return 'Presencial';
      return this.types.find((e) => e.id === this.job.place).label;
    },
  },
  props: {
    id: { default: false },
  },
  created() {
    //viene id o algún parámetro
    if (this.id) {
      this.loading = true;
      this.$dmtk.jobs.read(this.id).then((data) => {
        this.job = data.job;
        this.applications = data.applications;
        this.loading = false;
        this.$dmtk.jobs.recommended(this.id).then((data) => {
          this.profiles = data.profiles;
        });
      });
    } else {
      customAlert(
        'Ha ocurrido un error',
        'No se ha podido cargar su oferta. Por favor vuelva a intentarlo o contacte con soporte.',
      );
    }
  },
  methods: {
    nl2br: function (value) {
      return value.replaceAll('\n', '<br />');
    },
    getProfilesForJobURL(job) {
      return `/${job.activity.slug}/${job.location.slug}/`;
    },
    reactivate(job) {
      return this.$dmtk.jobs
        .reactivate(job._id)
        .then((result) => {
          job.status = result.status;
          this.$router.push({ path: `/empleo` });
        })
        .catch((e) => {
          customAlert(
            'Ha ocurrido un error',
            'Por favor vuelve a intentarlo dentro de unos minutos',
          );
        });
    },
  },
  template: `
    <div v-cloak>

      <span class="uk-badge uk-float-right uk-padding-small uk-text-uppercase">
        {{ statuses[job.status] }}
      </span>
      <h1 class="uk-margin-medium-top uk-text-bold">{{ job.title }}</h1>
      <div class="uk-grid">
        <div class="uk-width-expand">
          <p>
            Oferta de <strong>{{ job.activity.name }}</strong> en <strong>{{ job.location.title }}</strong>
            <br>
            <small>
              Añadida el {{ job.createdAt | dateFormat('D [de] MMMM') }}
              <span v-if="job.status === 'active'">
              | Caduca el {{ job.expiresAt | dateFormat('D [de] MMMM') }}
              </span>
            </small>
          </p>
        </div>
        <p class="uk-text-right">
          {{ employmentLabel }} / {{ placeLabel }}
        </p>
      </div>

      <h2>Descripción</h2>
      <div v-html="nl2br(job.description)"></div>

      <div v-if="job.requirements" class="uk-margin-medium-top">
        <h2>Requisitos</h2>
        <div>{{ job.requirements }}</div>
      </div>

      <h2>Inscripciones</h2>
      <div v-if="applications.length > 0">
        <table class="uk-table uk-table-striped">
          <tbody>
          <tr v-for="application in applications" :key="application.id">
            <td>
              <router-link :to="'/mensajes/'+application.threads[0]._id">
                {{ application.profile.display_name }}
              </router-link>
            </td>
            <td class="uk-width-small uk-text-right">
                <span :title="application.createdAt">
                  {{ application.createdAt | relativeTime }}
                </span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="uk-alert uk-alert-info" v-else>
        No se han encontrado inscripciones
      </div>

      <hr>
      <div class="uk-flex uk-flex-between">
        <router-link
          class="uk-button"
          to="/empleo"
        >
          Ver tus ofertas publicadas
        </router-link>
        <div>
          <button
            v-if="job.status === 'inactive'"
            class="uk-button uk-button-dmtk"
            @click="reactivate(job)"
          >
            Reactivar
          </button>
          <router-link
            v-if="['active', 'pending'].includes(job.status)"
            class="uk-button uk-button-dmtk"
            :to="{ name: 'job.form', params: {id: job._id} }"
          >
            Editar
          </router-link>
        </div>
      </div>

      <hr>

      <div v-if="profiles.totalDocs">
        <h2>Perfiles que te podrían interesar</h2>
        <div>
          <ProfilesBox :profiles="profiles.docs" :applied="applications.map(a => a.profile._id)" />
        </div>
        <p>
          <a :href="getProfilesForJobURL(job)" target="_blank">
            Ver más perfiles de <strong>{{ job.activity.name }}</strong> en <strong>{{ job.location.title }}</strong>
          </a>
        </p>
      </div>

      <Adsense unit="3423209573" />

    </div>
  `,
};
